var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-map"},[_c('v-mapbox',{attrs:{"map-style":"mapbox://styles/mapbox/streets-v11","access-token":_vm.mapToken,"center":_vm.mapCenter,"zoom":_vm.mapZoom}},[_c('v-mapbox-navigation-control'),_c('locations-layer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }